"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ActionButton = require("../styled/ActionButton");
/** @jsxRuntime classic */
/** @jsx jsx */

/**
 * @deprecated Please use ModalActionButton instead
 */
const XButton = props => {
  const {
    onClick,
    xButtonProps
  } = props;
  return (0, _core.jsx)(_ActionButton.StyledActionButton, (0, _extends2.default)({}, xButtonProps, {
    appearance: "borderless",
    type: "button",
    onClick: onClick
  }), (0, _core.jsx)(_lodestarIcons.CloseIcon, null));
};
exports.XButton = XButton;
//# sourceMappingURL=XButton.js.map